import {useAuthAxios} from 'hooks/api/useAuthAxios'
import {useFileDownload} from 'hooks/api/useFileDownload'

export const useDownloadDynamicDocument = () => {
  const authAxios = useAuthAxios()
  const {download} = useFileDownload()

  return async (documentId: string, employeeId: string) => {
    const path = `/api/dynamic_documents/${documentId}.pdf?employee_id=${employeeId}`
    const getter = () => authAxios.get(path, {responseType: 'arraybuffer'})

    download(getter)
  }
}
